import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../state/ApplicationState';
import { TabsNavigator } from '../components/TabsNavigator';
import { ClientsPage } from './clients';
import { LicencesPage } from './licenses';
import { UsersPage } from './users';
import { VersionsPage } from './versions';
import { Icon } from 'tacho-ui';
import { DistributorsPage } from './distributors';
import { LicenseTermsPage } from './licenseTerms';

export const MainContainer = () => {
    const { formatMessage } = useIntl();
    const activeRole = useSelector((state: ApplicationState) => state.common.activeRole);
    const tabs = [
        {
            name: formatMessage({ id: 'licencesPage' }),
            component: <LicencesPage />,
            icon: Icon.Licenses,
        },
        {
            name: formatMessage({ id: 'clientsPage' }),
            component: <ClientsPage />,
            icon: Icon.User,
        },
    ];

    if (activeRole === 2) {
        tabs.push({
            name: formatMessage({ id: 'distributorsPage' }),
            component: <DistributorsPage />,
            icon: Icon.Money,
        });
    }

    tabs.push({
        name: formatMessage({ id: 'versionsPage' }),
        component: <VersionsPage />,
        icon: Icon.SettingsVersions,
    });

    if (activeRole === 2) {
        tabs.push(
            {
                name: formatMessage({ id: 'usersPage' }),
                component: <UsersPage />,
                icon: Icon.User,
            },
            {
                name: formatMessage({ id: 'licenseTermsPage' }),
                component: <LicenseTermsPage />,
                icon: Icon.Document,
            },
        );
    }

    return <TabsNavigator renderOnlyActiveTab={false} className="mainNavBar" upperCaseTabs={true} tabs={tabs} />;
};
